export enum ScoreReportType {
    MONTHLY,
    QUARTERLY,
    MONTHLY_RMS,
}
